<div class="flex flex-col justify-start sidenav-body" [hidden]="!loaded">
  <div
    class="table-container"
    [style.height]="treeHeight"
    [hidden]="!areProjects"
  >
    <tree-display
      [style.height]="treeHeight"
      data-automation="tree-selector"
      [labelIdentifier]="'label'"
      [typeIdentifier]="'type'"
      [searchString]="filterValue"
      [searchProperties]="searchProperties"
      [selectedNodes]="selectedNodes"
      [allowDirectLink]="true"
      [hideIrrelevant]="true"
      [showControls]="true"
      [treeData]="treeData"
      (clicked$)="clicked($event)"
      (linked$)="linked($event)"
      [showSearch]="false"
    ></tree-display>
  </div>
  <div class="list-empty" [hidden]="areProjects">
    {{ 'project.list.none_configured' | translate }}
  </div>

  <div id="create-button-container" class="flex justify-end mt-4">
    <button
      id="create-button"
      (click)="createProject()"
      class="icon-btn x-btn x-btn-primary"
      data-automation="create-project-button"
      matRipple
    >
      <span>{{ 'project.list.button.create_project' | translate }}</span>
    </button>
  </div>
</div>
<div class="spinner-container" [hidden]="loaded">
  <mat-spinner mode="indeterminate" diameter="60"></mat-spinner>
</div>
